import { Component, Input, OnInit } from "@angular/core";
import {
  ExperienceStepModel,
  GeneralExpWizardInfoByLang,
} from "src/app/models/experience-steps.model";
import { LANGUAGE } from "src/app/services/experience/experience-steps.service";

@Component({
  selector: "app-location-step",
  templateUrl: "./location-step.component.html",
  styleUrls: ["./location-step.component.scss"],
})
export class LocationStepComponent implements OnInit {
  LANGUAGE = LANGUAGE;

  @Input() step: ExperienceStepModel;
  @Input() generalInfoByLang: GeneralExpWizardInfoByLang;
  @Input() experienceId: string;
  @Input() hasIssue: boolean;
  @Input() comments: Array<any>;
  @Input() commentLocation: boolean;
  @Input() experienceOrigin: boolean;
  @Input() experienceOriginUrl: string;

  public zoom: number;

  constructor() {}

  ngOnInit(): void {
    this.checkStepComplete();
  }

  changeLanguage(lang: string) {
    this.generalInfoByLang.language = lang;
    this.checkStepComplete();
  }

  getLocationEmitter($event) {
    this.generalInfoByLang.dataByLang[
      this.generalInfoByLang.language
    ].locationAddress = $event.expAddress;
    this.generalInfoByLang.dataByLang[
      this.generalInfoByLang.language
    ].locationDescription = $event.expDesc;
    this.generalInfoByLang.dataByLang[
      this.generalInfoByLang.language
    ].locationName = $event.addressName;
    this.generalInfoByLang.dataByLang[
      this.generalInfoByLang.language
    ].longitude = $event.longitude;
    this.generalInfoByLang.dataByLang[
      this.generalInfoByLang.language
    ].latitude = $event.latitude;

    this.checkStepComplete();
  }

  checkStepComplete() {
    if (
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .locationAddress &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .longitude &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .latitude
    ) {
      this.step.isComplete = true;
    } else {
      this.step.isComplete = false;
    }
  }
}
